module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-9-21247756079083804db3581bf0e6e4e0.jpg";